/**
 * Shared constants of our application.
 */
export const VIDEOCONFERENCE_CONSTANTS = {
  URL_PARAM_ATTENDANT: 'access',
  URL_PARAM_PIN: 'pin',
  MONTHS: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  DISCONNECTED_STATUS: {
    START: 'start',
    OVER: 'over',
    NOT_STARTED: 'not_started',
    HUNG_UP: 'hung_up',
    WAITING: 'waiting',
    PASSWORD_REQUIRED: 'password_required',
    NOT_FOUND: 'not_found',
  },
  ICON_BUTTONS: {
    SPEAKER: 'speaker',
    SPEAKER_OFF: 'speaker-off',
    MIC: 'mic',
    MIC_OFF: 'mic-off',
    CAMERA: 'camera',
    CAMERA_OFF: 'camera-off',
    MINIATURE: 'miniature',
    PHONE_OFF: 'phone-off',
    SHARE_SCREEN: 'share-screen',
    SHARE_SCREEN_OFF: 'share-screen-off',
    CHAT: 'chat',
  },
  VIDEO_TYPES: {
    CAMERA: 'camera',
  },
  CHAT: {
    OWNER_MINE: 'mine',
    OWNER_THEIRS: 'theirs',
    MESSAGE_TYPES: {
      MSG: 'msg',
      FILE: 'file',
      FILE_PDF_END: 'file-pdf-end',
      FILE_IMAGE_END: 'file-image-end',
    },
    ERROR_FILE_SIZE: 'errorSize',
    ERROR_FILE_TYPE: 'errorType',
  },
  SCREEN_SHARING: {
    SCREEN: 'screen',
    MAXRESOLUTION: {
      WIDTH: 1920,
      HEIGHT: 1080,
    },
    REASONS: {
      CLIENT_DISCONNECTED: 'clientDisconnected',
    },
  },
  MEDIA_DEVICES_ERRORS: {
    NOT_ALLOWED_ERROR: 'NotAllowedError',
    NOT_READABLE_ERROR: 'NotReadableError',
  },
  GET_CREDENTIALS_ERROR: 'getNetWorkTestCredentials',
};
